import { ShowHide_bx_tel } from './checkout';

export default () => {
  const $interactionCheck = $('.js-apn-itxCheck');
  const $interactionCheckButton = $('.js-apn-itxCheckButton');
  const $interactionRemoveButton = $('.js-apn-itxRemoveButton');

  if ($interactionCheck.length && $interactionCheckButton.length) {
    (($) => {
      const $interactionCheckFailure = $interactionCheck.find('.js-apn-itxFailure'),
        $interactionCheckSuccess = $interactionCheck.find('.js-apn-itxSuccess');

      const resetInteractionCheck = () => {
        $interactionCheckSuccess.addClass('hidden');
        $interactionCheckFailure.addClass('hidden');
        $interactionCheck.addClass('hidden');
        $interactionCheck.find('.js-apn-itxInteraction').not('.hidden').remove();
      };

      const getPznList = () => {
        let pznItems = [];
        $('span[data-contains="pzn"]').each((index, element) => {
          pznItems.push(element.innerText);
        });
        return pznItems;
      };

      $interactionCheckButton.click(() => {
        resetInteractionCheck();
        $interactionCheckButton.attr('disabled', 'disabled');
        showLoadingScreen();

        $.ajax({
          url: '/rpc.php?action=interaktionsinfo',
          data: {
            pznlist: getPznList(),
          },
          dataType: 'json',
          method: 'POST',
        })
          .done((response) => {
            if (response.length) {
              const $interactionTemplate = $interactionCheck.find('.js-apn-itxInteraction'),
                $messageTemplate = $interactionTemplate.find('.js-apn-itxMessage');

              response.forEach((itx) => {
                let $interaction = $interactionTemplate.clone();
                $interaction.find('.js-apn-itxMessages').empty();
                $interaction.find('.js-apn-itxProduct1').html(itx['products'][0]['name']);
                $interaction.find('.js-apn-itxProduct2').html(itx['products'][1]['name']);
                $interaction.find('.js-apn-itxPzn1').html(itx['products'][0]['pzn']);
                $interaction.find('.js-apn-itxPzn2').html(itx['products'][1]['pzn']);
                $interaction.find('.js-apn-itxSeverity').html(itx['meta']['interactionScore']['shortText1']);
                $interaction.find('.js-apn-itxDesc').html(itx['meta']['interactionScore']['fullText1']);
                $interaction.find('.js-apn-itxAdditionalDesc').html(itx['meta']['interactionScore']['fullText2']); //  + itx['meta']['interactionScore']['shortText2']
                $interaction.find('.js-apn-itxDate').html(itx['meta']['timeDataSet']);
                itx['messages'].forEach((message) => {
                  let $message = $messageTemplate.clone();
                  $message.find('.js-apn-itxMessageDesc').html(message['description']);
                  $message.find('.js-apn-itxMessageInteraction').html(message['interaction']);
                  $interaction.find('.js-apn-itxMessages').append($message);
                });
                $interaction.removeClass('hidden');
                $interactionCheck.find('.js-apn-itxInteractions').append($interaction);
              });
            } else {
              $interactionCheckSuccess.removeClass('hidden');
            }
          })
          .fail((response) => {
            if (response.status === 200 && response.responseText === '') {
              // this is the case if not interactions are known, server respond is empty
              $interactionCheckSuccess.removeClass('hidden');
            } else {
              $interactionCheckFailure.removeClass('hidden');
            }
          })
          .always(() => {
            $interactionCheck.removeClass('hidden');
            $interactionCheckButton.removeAttr('disabled');

            $('.js-intercation-step_1').show();
            // removeLoadingScreen();
          });
      });

      $interactionRemoveButton.click((event) => {
        let $pzn = $(event.target).data('pzn');
        console.log($pzn);
        //showLoadingScreen();

        $.ajax({
          url: '/rpc.php?action=interactionscheck&do=remove&pzn=' + $pzn,
          dataType: 'json',
          method: 'GET',
        })
          .done((response) => {
            if ((response = 1)) {
              $('#product-' + $pzn).hide(400);
              //removeLoadingScreen();
              //hideLoadingScreen();
            } else {
              console.log('invalid response:');
              console.log(response);
            }
          })
          .always(() => {});
      });
    })(jQuery);
  }
};
